import type { SlateBlock, CalloutBlock } from '@atlas/renderer';

export default function isCalloutBlock(block: SlateBlock): block is CalloutBlock {
    return block.type === 'callout';
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isCalloutBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
